import { useState } from "preact/hooks";
import {
  GET,
  GET_SPARE_DEVICE,
  GET_SPARE_DEVICE_QUERY,
} from "../../../services";
import { useMessage } from "../../../hooks/useMessage";
import { IStateSpareDevice } from "../interfaces/state";

export const useGetData = () => {
  const [data, setData] = useState([] as IStateSpareDevice[]);
  const { openMessage } = useMessage();

  const onFetchData = async () => {
    try {
      const res = await GET(GET_SPARE_DEVICE);
      const { spares: d } = res.result;
      const items: IStateSpareDevice[] = d.map(
        (e: IStateSpareDevice, i: number) => ({
          ...e,
          index: i + 1,
        })
      );
      setData(items);
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (qurryString: any) => {
    try {
      const res = await GET(GET_SPARE_DEVICE_QUERY(qurryString));
      const { spares: d } = res.result;
      const items: IStateSpareDevice[] = d.map(
        (e: IStateSpareDevice, i: number) => ({
          ...e,
          index: i + 1,
        })
      );
      setData(items);
      if (d.length === 0) {
        openMessage("error", "ไม่พบข้อมูล");
      }
      if (d.length > 0) {
        openMessage("success", res.message);
      }
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.message);
    }
  };

  return {
    data,
    setData,
    onFetchData,
    onSearch,
  };
};
